import React, { useEffect, useState, useContext } from 'react'
import { format } from 'date-fns'
import ReactTooltip from 'react-tooltip'
import { toast } from 'react-toastify'
import { FiPlusCircle } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'

import { api, authHeaders } from '../../../../services/api'

import scrollUtils from '../../../../util/scroll'
import { stringToDate, getDateString, getDate } from '../../../../util/date'
import useQuery from '../../../../hooks/useQuery'
import BoxDadosBasicos from '../../../../boxes/EspacoMedico/DadosBasicos'
import BoxDadosBasicosEmpresa from '../../../../boxes/EspacoMedico/DadosBasicosEmpresa'
import BoxDadosPessoais from '../../../../boxes/EspacoMedico/DadosPessoais'
import BoxDadosCorporativos from '../../../../boxes/EspacoMedico/DadosCorporativos'
import BoxEndereco from '../../../../boxes/EspacoMedico/Endereco'
import BoxContatos from '../../../../boxes/EspacoMedico/Contatos'
import BoxArquivos from '../../../../boxes/Arquivos'

import Modal from '../../../../components/Modal'
import GerenciamentoDocumentos from '../../../../components/GerenciamentoDocumentos'

import { loadTips } from '../../../../util/tip'
import { TipContext } from '../../../../contexts/TipContext'

import {
    Container,
    BoxDocumentos
} from './styles'

import { GlobalContext } from '../../../../contexts/GlobalContext'

export default function () {
    const { setCodigo } = useContext(TipContext)

    const { contato, upd_doc } = useQuery()
    const history = useHistory()

    const { user } = useContext(GlobalContext)

    const [pessoa, setPessoa] = useState(null)
    const [showModalDocumentos, setShowModalDocumentos] = useState(false)

    async function loadPessoa() {
        try {
            const response = await api.get(`pessoa/${user.pessoa.id}`, authHeaders())

            const nomes = response.nome.split(' ')
            response.nome_reduzido = `${nomes[0]} ${nomes.slice(1, nomes.length - 1).map(sobrenome => `${sobrenome[0]}. `).join(' ')}${nomes[nomes.length - 1]}`

            response.documentos = response.documentos

            response.endereco = response.endereco

            response.contato = [
                ...response.contato.map(contato => ({
                    ...contato,
                    icone: contato.tipo_contato.icone
                }))
            ]

            response.dados_pessoais = {
                data_nascimento: response.data_nascimento ? format(stringToDate(response.data_nascimento), 'dd/MM/yyyy') : '',
                site: response.empresa?.site,
                nome_fantasia: response.empresa?.nome_fantasia
            }

            setPessoa(response)
        } catch (e) {
            toast.error(e.msg)
        }
    }

    useEffect(() => {
        scrollUtils.toTop()

        if (user) {
            loadPessoa()
        }
    }, [user])

    useEffect(() => {
        if (contato) {
            setTimeout(() => {
                scrollUtils.toElement('.box-local-trabalho')
            }, 500)
        }
    }, [])

    useEffect(() => {
        setShowModalDocumentos(upd_doc && pessoa)
    }, [pessoa])

    useEffect(() => {
        loadTips(setCodigo, 'form_associado_espaco_medico')
    }, [])

    async function reload() {
        setPessoa(null)
        setShowModalDocumentos(false)

        await loadPessoa()
    }

    async function updateDocumentos(values) {
        try {
            await api.put(`documentos/${pessoa.id}`, {
                documentos: values.documentos
                    .map(doc => ({
                        arquivo: doc.arquivo,
                        identificador: doc.identificador,
                        extra: doc.validade ? {
                            validade: getDateString(getDate(doc.validade))
                        } : doc.dataEmissao && doc.orgaoEmissor ? {
                            data_emissao: getDateString(getDate(doc.dataEmissao)),
                            orgao_emissor: doc.orgaoEmissor
                        } : doc.orgaoEmissor ? { orgao_emissor: doc.orgaoEmissor }
                            : doc.dataEmissao ? {
                                data_emissao: getDateString(getDate(doc.dataEmissao))
                            } : null,
                        tipo_documento: doc.tipo_documento.value
                    }))
            }, authHeaders())

            toast.success('Documentos atualizados.')

            history.push('/dados_cadastrais')
        } catch (e) {
            toast.error('Ocorreu um erro ao tentar atualizar os documentos.')
        }
    }

    return (
        <Container>
            <main className="animated fadeIn faster flex flex-col lg:grid lg:grid-cols-2 xl:grid-cols-3">
                {pessoa?.tipo === 'PJ' ? (
                    <>
                        <BoxDadosBasicosEmpresa pessoa={pessoa} reload={reload} />

                        <BoxDadosCorporativos pessoa={pessoa} reload={reload} />
                    </>
                ) : (
                    <>
                        <BoxDadosBasicos pessoa={pessoa} reload={reload} className="col-span-3" />

                        <BoxDadosPessoais pessoa={pessoa} reload={reload} />
                    </>
                )}

                <BoxEndereco pessoa={pessoa} reload={reload} className="col-span-2" />

                <BoxContatos pessoa={pessoa} reload={reload} className="col-span-3" />

                <BoxDocumentos className="animated fadeInUp delay-900ms col-span-3 bg-white text-slate-800">
                    <div className="flex gap-4 justify-between items-center mb-3">
                        <h1 className="text-slate-800 my-0 mx-2 my-0">Documentos</h1>

                        <div 
                            className="flex items-center gap-1.5 cursor-pointer hover:opacity-80 w-fit hover:bg-slate-100 rounded-md px-4 py-2 justify-self-end"
                            onClick={() => { setShowModalDocumentos(true) }}
                        >
                            <FiPlusCircle
                                size={20}
                                color="#1e293b"
                            />

                            <span className="text-center text-xs">Adicionar</span>
                        </div>
                    </div>

                    <BoxArquivos
                        title={null}
                        arquivos={pessoa?.documentos.map(doc => {
                            let nome = doc.tipo_documento.descricao
                            
                            if(nome === 'Outros') {
                                nome = doc.identificador
                            }

                            return {
                                ...doc,
                                link: doc.arquivo?.link || '',
                                nome
                            }
                        })}
                    />
                </BoxDocumentos>
            </main>

            <ReactTooltip
                id="tooltip"
                place="top"
                effect="solid"
                backgroundColor="#fff"
                arrowColor="#fff"
                textColor="#424242"
                className="tooltip-default"
            />

            <Modal
                isOpen={showModalDocumentos}
                handleClose={() => { setShowModalDocumentos(false) }}
                title="Gerenciamento de documentos"
            >
                <p style={{ fontSize: 13 }} className="text-slate-500 mx-2 mb-3">Os arquivos anexados e informações fornecidas neste cadastro são de responsabilidade do usuário.</p>

                <GerenciamentoDocumentos
                    handleSubmit={updateDocumentos}
                    documentos={pessoa?.documentos.map(doc => ({
                        id: doc.id,
                        arquivo: doc.arquivo,
                        tipo_documento: doc.tipo_documento,
                        extra: doc.extra,
                        identificador: doc.identificador
                    }))}
                    enablePreview={false}
                />
            </Modal>
        </Container>
    )
}
